<template>
  <div class="colo-md-12 mx-auto position-relative">

    <assistant-chat-viewer
      v-if="
        !!value.advanceSettings?.hasAssistants &&
        !!value.advanceSettings?.aiChatConfig?.assistantId
      "
      :aiChatConfig="value.advanceSettings.aiChatConfig"
    />

    <v-responsive
      aspect-ratio=".611"
      style="width: 100%; margin: auto; max-width: calc(100vw - 12px)"
    >
      <v-scale-transition mode="out-in" origin="center">
        <div
          v-if="showWelcome && value.photo.hasWelcome"
          key="loading"
          class="col-md-11 mx-auto elevation-3 d-flex"
          style="min-height: 80vh"
        >
          <div v-if="value.photo.welcome === ''" class="col m-auto">
            <atom-spinner
              :animation-duration="1000"
              :size="80"
              class="mx-auto justify-content-center"
              color="#ff1d5e"
            />
          </div>
          <div v-if="value.photo.welcome !== ''" class="m-auto">
            <img
              :src="value.photo.welcome"
              alt=""
              class="bg-white rounded-circle mx-auto my-auto"
              width="100"
            />
          </div>
        </div>

        <div
          v-else-if="locationPage && value.coordinates"
          key="location"
          class="col-md-12 elevation-3"
        >
          <v-card-title class="px-0 pt-0 justify-end">
            <v-btn
              class="mx-2 mr-auto text-left"
              color="white"
              small
              @click="locationPage = false"
            >
              بازگشت
              <v-icon class="ms-2" color="black">mdi-keyboard-backspace</v-icon>
            </v-btn>
          </v-card-title>

          <div>
            <p>
              <span class="fa fa-car ml-1 text-danger"></span>
              پس از کلیک بر روی لوکیشن مسیریاب خودرا انتخاب کنید.
            </p>

            <v-card
              v-if="locLoading"
              class="d-flex align-center justify-center"
              flat
              height="400"
              width="100%"
            >
              <atom-spinner
                :animation-duration="1000"
                :size="120"
                class="mx-auto justify-content-center"
                color="#ff1d5e"
              />
            </v-card>

            <mapir
              :apiKey="value.apiKey"
              :center="value.coordinates"
              :zoom="17"
              class="col-md-12"
              style="width: 100%; height: 400px"
              @click.self="openMap"
            >
              <mapNavigationControl position="top-right" />
              <mapMarker
                :coordinates.sync="value.coordinates"
                color="red"
                kind="marker"
                readonly
              >
                <template v-slot:marker>
                  <v-icon>mdi-map-marker</v-icon>
                </template>
              </mapMarker>
            </mapir>
          </div>

          <div class="col-md-12 flex py-2 my-3">
            <p>
              <span><v-icon color="red">mdi-map-marker</v-icon></span
              >{{ value.address }}
            </p>
          </div>
        </div>

        <v-card
          key="theme"
          :class="expand ? 'expanded' : 'contracted'"
          class="content-holder"
          flat
          height="100%"
          min-height="50vh"
        >
          <v-responsive
            :aspect-ratio="expand ? '.673' : '1'"
            :style="{ background: value.pallete.bodyColor }"
            class="header-img-container"
          >
            <transition mode="out-in" name="fade-head-img">
              <img
                v-if="(expand || !value.photo.profile) && getHeaderImg"
                key="back"
                :src="getHeaderImg"
                alt=""
                class="header-img-bg"
              />
              <img
                v-else-if="getHeaderImg"
                key="logo"
                :src="getHeaderImg"
                alt=""
                class="header-img-bg"
              />
            </transition>
          </v-responsive>

          <div
            :style="{
              background: value.pallete.headColor,
              color: value.pallete.textColor,
            }"
            class="sticky-name-holder col-md-12"
          >
            <div>
              <v-card-title
                class="py-2 ms-1 font-size-h4 font-weight-bold"
                v-text="value.organizationName"
              />
              <v-card-text :style="{ 'text-size': titleComputer }">
                <v-icon :color="value.pallete.textColor" small>mdi-star</v-icon>
                {{ value.subOrgan }}
              </v-card-text>
            </div>
            <v-menu :bottom="!expand" :top="expand" offset-y right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="value.pallete.textColor"
                  :loading="vcfLoading"
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list
                :style="{ background: value.pallete.headColor }"
                dark
                dense
              >
                <v-list-item
                  v-if="!!value.companyNumber"
                  :href="`tel:${value.companyNumber}`"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-phone</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>شماره تلفن</v-list-item-title>
                </v-list-item>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-card-account-phone-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>باشگاه مشتریان</v-list-item-title>
                </v-list-item>

                <v-list-item
                  v-if="
                    (value.phoneNumber &&
                      value.phoneNumber.length > 0 &&
                      value.phoneNumber[0].number) ||
                    value.companyNumber
                  "
                  @click="getVcf"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-plus</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>ذخیره مخاطب</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <v-btn
            :style="{
              background: value.pallete.headColor,
              color: value.pallete.textColor,
            }"
            absolute
            class="px-0 rounded-pill btn-action"
            depressed
            large
            min-width="44"
            top
            @click="expand = !expand"
          >
            <transition mode="out-in" name="expand-btn">
              <v-icon v-if="!expand" key="close">mdi-chevron-left</v-icon>
              <v-icon v-else key="open">mdi-menu</v-icon>
            </transition>
          </v-btn>

          <div class="main-wrapper">
            <div class="pt-4 text-right">
              <p v-if="value.singleProduct.name" class="text-dark text-right">
                <span class="font-weight-bold">
                  <span>نام محصول</span>
                  :
                </span>
                {{ value.singleProduct.name }}
              </p>

              <p v-if="value.singleProduct.price" class="text-dark text-right">
                <span class="font-weight-bold"> <span>قیمت</span> : </span>
                <span
                  :style="{
                    'text-decoration-line': value.singleProduct.discount
                      ? 'line-through'
                      : '',
                  }"
                >
                  {{ value.singleProduct.price | currency | persianNum }}
                  ﷼</span
                >
                <span
                  v-if="computePrice"
                  class="font-weight-bold float-end mr-10"
                >
                  {{ computePrice | currency | persianNum }} ﷼
                </span>
              </p>

              <v-btn
                v-if="!!btnSetting"
                :href="btnSetting.link"
                :style="{
                  background: btnSetting.background,
                  color: btnSetting.color,
                }"
                class="mb-2"
                target="_blank"
              >
                <v-icon v-if="!!btnSetting.icon" left>{{
                  btnSetting.icon
                }}</v-icon>
                {{ btnSetting.title }}
              </v-btn>

              <div v-if="value.singleProduct.description">
                <span><v-icon>mdi-comment-account-outline</v-icon></span> :
                <span class="font-weight-bolder">درباره محصول</span>
                <div class="col-md-12 mb-2">
                  <pre
                    :class="
                      isTruncate
                        ? 'text-dark text-right my-0'
                        : 'text-dark text-right my-0'
                    "
                    v-html="trancateTxts"
                  />
                  <v-btn
                    v-if="
                      value.singleProduct.description.length > 200 ||
                      value.singleProduct.description.split('<div>').length > 3
                    "
                    class="ms-n4"
                    color="primary"
                    text
                    @click="isTruncate = !isTruncate"
                  >
                    {{ isTruncate ? "مشاهده بیشتر" : "مشاهده کمتر" }}
                  </v-btn>
                </div>
              </div>

              <div v-if="value.audiosGallery.audios.length > 0" class="pa-2">
                <v-card-title>گالری فایل صوتی</v-card-title>
                <v-row class="d-flex flex-column align-items-center">
                  <v-col
                    cols="12"
                    v-for="(audio, i) in value.audiosGallery.audios"
                    :key="i"
                    class="d-flex flex-column align-items-center"
                  >
                    <v-card
                      :style="{
                        background: audio?.background ?? 'transparent',
                      }"
                      :color="value.pallete.bodyColor"
                      width="300"
                      class="d-flex align-items-center justify-content-center flex-column"
                    >
                      <v-card-title v-if="audio?.ti?.length > 0">{{
                        audio?.ti
                      }}</v-card-title>
                      <v-card-subtitle
                        class="pa-0"
                        v-if="audio?.desc?.length"
                        >{{ audio?.desc }}</v-card-subtitle
                      >
                      <component
                        :is="value.audiosGallery.audioType"
                        :file="audio.full_path"
                        :link="false"
                        :inf="{
                          ti: audio?.ti,
                          link: audio?.link,
                          title: audio?.title,
                          desc: audio?.desc,
                        }"
                        :image="audio?.image"
                        :title="
                          audio.title.length > 0 ? audio.title : 'فایل صوتی'
                        "
                        width="100%"
                        :height="
                          value.audiosGallery.audioType == 'newPlayer'
                            ? 280
                            : 150
                        "
                        :flat="true"
                        :audioSound="false"
                        :color="audio?.color"
                        background="transparent"
                      />
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div v-if="value.singleProduct.image">
                <v-img :src="value.singleProduct.image" />
              </div>

              <div v-if="hasExtra">
                <v-card-title class="px-0 pb-0">سایر ویژگی‌ها</v-card-title>
                <extra-shown v-model="value.singleProduct.extra" />
              </div>
              <div
                v-if="value?.FeedBack && value.FeedBack.items?.length > 0"
                class="mb-4"
              >
                <div
                  :style="{
                    background: value.pallete.headColor,
                    color: value.pallete.textColor,
                    border: '1px solid #7e8299',
                    clipPath: 'polygon(15% 0%, 100% 0%, 90% 100%, 0% 100%)',
                    width: '100%',
                    cursor: 'pointer',
                  }"
                  class="p-4 pl-10 d-flex align-center justify-space-between"
                  @click="showFeedback = !showFeedback"
                >
                  <div class="d-flex align-center">
                    <v-icon left color="white">mdi-message-star-outline</v-icon>
                    <span class="font-weight-bold"> بازخورد </span>
                  </div>
                  <v-icon color="white">
                    {{ showFeedback ? "mdi-minus" : "mdi-plus" }}
                  </v-icon>
                </div>

                <v-expand-transition>
                  <div
                    v-show="showFeedback"
                    class="pa-4"
                    style="
                      background: white;
                      border: 1px solid #e0e0e0;
                      border-top: none;
                    "
                  >
                    <b-feedback-view
                      v-model="value.FeedBack"
                      :style="{ background: 'transparent !important' }"
                    />
                  </div>
                </v-expand-transition>
              </div>

              <div
                v-if="$route.name.toLowerCase().includes('productpro')"
                class="mb-4"
              >
                <div
                  :style="{
                    background: value.pallete.headColor,
                    color: value.pallete.textColor,
                    border: '1px solid #7e8299',
                    clipPath: 'polygon(15% 0%, 100% 0%, 90% 100%, 0% 100%)',
                    width: '100%',
                    cursor: 'pointer',
                  }"
                  class="p-4 pl-10 d-flex align-center justify-space-between"
                  @click="showConsult = !showConsult"
                >
                  <div class="d-flex align-center">
                    <v-icon left color="white">mdi-message-draw-outline</v-icon>
                    <span class="font-weight-bold"> فرم درخواست </span>
                  </div>
                  <v-icon color="white">
                    {{ showConsult ? "mdi-minus" : "mdi-plus" }}
                  </v-icon>
                </div>

                <v-expand-transition>
                  <div
                    v-show="showConsult"
                    class="pa-4"
                    style="
                      background: white;
                      border: 1px solid #e0e0e0;
                      border-top: none;
                    "
                  >
                    <consultation-new-show
                      v-model="value.consultationNew"
                      :color="value.pallete.textColor"
                      :style="{ background: 'transparent !important' }"
                    />
                  </div>
                </v-expand-transition>
              </div>
              <v-card-actions
                v-if="!!value.singleProduct && !!value.singleProduct.payLink"
                class="pt-0 mt-n2 mb-2"
              >
                <v-btn
                  :href="value.singleProduct.payLink"
                  :style="{
                    background: value.singleProduct.btnSetting.background,
                    color: value.singleProduct.btnSetting.color,
                  }"
                  target="_blank"
                >
                  <v-icon
                    v-if="value.singleProduct.btnSetting.icon"
                    class="ml-2"
                    >{{ value.singleProduct.btnSetting.icon }}
                  </v-icon>
                  {{ value.singleProduct.btnSetting.title }}
                </v-btn>
              </v-card-actions>

              <template
                v-if="value.Features.show === 'accordion'"
                class="px-0 mx-0 col-md-12 mb-4"
              >
                <div
                  v-for="(item, index) in value.Features.details"
                  :key="index"
                  class="col-md-12"
                >
                  <div
                    :style="{
                      background: value.pallete.headColor,
                      color: value.pallete.textColor,
                    }"
                    class="col-md-12 p-4"
                    style="
                      border: 1px solid #7e8299;
                      clip-path: polygon(15% 0%, 100% 0%, 90% 100%, 0% 100%);
                      width: 100%;
                      cursor: pointer;
                    "
                    @click="item.showIt = !item.showIt"
                  >
                    <div class="mt-0 pt-0 px-4 flex">
                      <v-icon
                        class="float-end ml-3 mt-0 pt-0"
                        color="white"
                        left
                      >
                        <template v-if="item.showIt" class="mt-0 pt-0"
                          >mdi-minus</template
                        >
                        <template v-else>mdi-plus</template>
                      </v-icon>
                      <span
                        :style="{ color: value.pallete.headColor }"
                        class="font-weight-bold text-right mr-2"
                        >{{ item.name }}</span
                      >
                    </div>
                  </div>
                  <v-scroll-x-reverse-transition>
                    <div v-show="item.showIt">
                      <extra-shown v-model="item.value" font-color="black" />
                    </div>
                  </v-scroll-x-reverse-transition>
                </div>
              </template>

              <image-slider
                v-if="value.photo.gallery"
                v-model="value.photo.gallery"
              />

              <div
                v-if="
                  value.VideoGallerySingle &&
                  value.VideoGallerySingle.videos &&
                  value.VideoGallerySingle.videos.length > 0
                "
              >
                <v-card
                  v-for="(item, i) in value.VideoGallerySingle.videos"
                  :key="i"
                  class="transparent text-center"
                  flat
                  style="max-width: 100%"
                >
                  <v-card-title
                    :class="{ 'blue--text clickable': item.link }"
                    :href="fixLink(item.link)"
                    :tag="item.link ? 'a' : 'div'"
                    class="pa-2 text-break"
                    target="_blank"
                    v-text="item.title"
                  />
                  <iframe
                    :src="item.url"
                    style="max-width: 100%; height: auto"
                  />
                  <pre v-html="item.description" />
                </v-card>
              </div>

              <div v-if="value.aboutUs">
                <span><v-icon>mdi-domain</v-icon></span> :
                <span class="font-weight-bolder">درباره شرکت</span>
                <div class="col-md-12 mb-2">
                  <pre
                    :class="
                      isTruncate1
                        ? 'text-dark text-right my-0'
                        : 'text-dark text-right my-0'
                    "
                    v-html="trancateTxts1"
                  />
                  <v-btn
                    v-if="
                      value.aboutUs.length > 200 ||
                      value.aboutUs.split('<div>').length > 3
                    "
                    class="ms-n4"
                    color="primary"
                    text
                    @click="isTruncate1 = !isTruncate1"
                  >
                    {{ isTruncate1 ? "مشاهده بیشتر" : "مشاهده کمتر" }}
                  </v-btn>
                </div>
              </div>

              <extra-shown v-model="value.extraFields" font-color="black" />

              <div
                v-if="
                  value.phoneNumber.length > 0 && value.phoneNumber[0].number
                "
              >
                <p
                  v-for="item in value.phoneNumber"
                  class="text-dark text-right clickable link-tag"
                  @click="rangMe(item.number)"
                >
                  <v-icon color="red">mdi-phone-outline</v-icon>
                  : {{ item.text || "" }} {{ item.number }}
                </p>
              </div>

              <p
                v-if="value.companyNumber"
                class="text-dark text-right"
                @click="rangMe(value.companyNumber)"
              >
                <span class="font-weight-bold">
                  <span>
                    <v-icon color="red">mdi-phone-outline</v-icon> :
                  </span>
                </span>
                <span class="link-tag" dir="ltr"
                  >{{ value.companyNumberName
                  }}{{ value.companyNumber | persianNum }}</span
                >
              </p>

              <p v-if="value.fax" class="text-dark text-right">
                <span class="font-weight-bold">
                  <span><v-icon>mdi-fax</v-icon> : </span>
                </span>
                <span dir="ltr">{{ value.fax | persianNum }}</span>
              </p>

              <a :href="`mailto:${value.email}`" target="_blank">
                <p
                  v-if="value.email"
                  class="text-dark text-right pt-1 clickable link-tag"
                >
                  <span><v-icon color="red">mdi-email-outline</v-icon></span>
                  : {{ value.email }}
                </p>
              </a>

              <p
                v-if="value.website"
                class="text-dark text-right pb-3 link-tag"
                @click="goToUrl(value.website)"
              >
                <span><v-icon color="blue">mdi-earth</v-icon></span> :
                {{ value.website }}
              </p>

              <p v-if="value.location" class="text-dark text-right">
                <span class="font-weight-bold">
                  <span><v-icon>mdi-map-marker</v-icon> : </span>
                </span>
                <span dir="ltr">{{ value.location }}</span>
              </p>

              <p v-if="value.codePostal" class="text-dark text-right">
                <span class="font-weight-bold">
                  <span><v-icon>mdi-post</v-icon> : </span>
                </span>
                <span dir="ltr">{{ value.codePostal | persianNum }}</span>
              </p>

              <certificates-view v-model="value.singleProduct.arm" />
            </div>
          </div>

          <div
            :style="{ background: value.pallete.bodyColor }"
            class="social-wrapper"
          >
            <v-row justify="center" no-gutters>
              <v-col
                v-for="(item, index) in thirdOne"
                :key="index"
                class="text-center"
                cols="3"
              >
                <v-btn
                  :style="{ background: value.pallete.headColor }"
                  class="px-0"
                  depressed
                  min-width="52"
                  x-large
                  @click="goToUrl(item.url, item.pattern)"
                >
                  <img :src="item.img" alt="" class="social-img" />
                </v-btn>
              </v-col>

              <v-col
                v-if="computeFields.length > 0"
                class="text-center"
                cols="3"
              >
                <v-menu
                  class="overflow-y-auto"
                  nudge-top="40"
                  right
                  style="max-height: 30px !important"
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :style="{ background: value.pallete.headColor }"
                      class="px-0"
                      depressed
                      min-width="52"
                      v-bind="attrs"
                      x-large
                      v-on="on"
                    >
                      <v-icon color="white" size="28">mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list
                    :style="{ background: value.pallete.bodyColor }"
                    dark
                    min-width="150"
                  >
                    <v-list-item
                      v-for="(item, index) in computeFields"
                      :key="index"
                      link
                      @click="goToUrl(item.url, item.pattern)"
                    >
                      <v-list-item-icon>
                        <v-btn dark icon>
                          <img :src="item.img" alt="" class="social-img" />
                        </v-btn>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <!--                        {{ item.pattern }}-->
                        <v-list-item-title v-text="item.label" />
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-scale-transition>
    </v-responsive>
  </div>
</template>

<script>
import axios from "axios";
import { Bus } from "../../../main";
import {
  mapGeolocateControl,
  mapir,
  mapMarker,
  mapNavigationControl,
} from "mapir-vue";
import { AtomSpinner } from "epic-spinners";
import {
  VFadeTransition,
  VScaleTransition,
  VSlideXTransition,
  VSlideYTransition,
} from "vuetify/lib";
import GallerySlider from "../../pages/businessPage/components/view/gallerySlider";
import ImageSlider from "../../../view/components/Gallery/imageSlider";
import MockUpMain from "@/view/pages/businessPage/components/mockUp";
import ExtraShown from "@/view/components/Product/extraShown";
import CertificatesView from "../../pages/product/certificatesView";
import AudioPlayerCard from "../UploadCenter/voiceGallery/components/audio/audioPlayerCard.vue";
import newPlayer from "../UploadCenter/voiceGallery/components/audio/newPlayer.vue";
import newPlayer2 from "../UploadCenter/voiceGallery/components/audio/newPlayer2.vue";
import BFeedbackView from "@/view/pages/businessPage/components/view/bFeedbackView.vue";
import consultationNewShow from "@/view/components/consultationNew/consultationNewShow.vue";
import assistantChatViewer from "@/view/pages/qrland/components/assistantChatViewer.vue";

export default {
  name: "newProCard",

  components: {
    CertificatesView,
    ExtraShown,
    MockUpMain,
    ImageSlider,
    GallerySlider,
    mapGeolocateControl,
    mapir,
    mapMarker,
    mapNavigationControl,
    AtomSpinner,
    AudioPlayerCard,
    newPlayer,
    newPlayer2,
    BFeedbackView,
    consultationNewShow,
    assistantChatViewer,
  },

  props: {
    value: Object,
    color: Object,
  },

  data: () => ({
    showFeedback: false,
    showConsult: false,
    expand: true,
    showIt: false,
    isTruncate: true,
    isTruncate1: true,
    vcfLoading: false,
    showWelcome: false,
    locationPage: false,
    locLoading: false,
    components: {
      scale: VScaleTransition,
      slideX: VSlideXTransition,
      slideY: VSlideYTransition,
      fade: VFadeTransition,
    },
  }),

  mounted() {
    Bus.$on("showMe", (value) => {
      if (this.value?.photo.hasWelcome) {
        this.showWelcome = true;
        this.locationPage = false;
        setTimeout(() => {
          this.locationPage = false;
          this.showWelcome = false;
        }, 3000);
      }
    });

    if (
      !this.value ||
      !this.value.pallete ||
      Object.keys(this.value.pallete).length <= 0 ||
      this.$route.name === "qr.cardVisit"
    ) {
      this.valueComputed.pallete = {
        headColor: "linear-gradient(to top left , #00BCD4FF, #2F0743FF)",
        bodyColor: "linear-gradient(to top left , #006064FF, #03A9F4FF)",
        textColor: "#ffffff",
        borderColor: "#393939",
      };
    }
  },

  computed: {
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    thirdOne() {
      let top = {};

      Object.entries(this.value.socialMedia)
        .slice(0, 3)
        .forEach(([x, y]) => {
          top[x] = y[0];
        });

      return top;
    },
    computeFields() {
      let extra = [];

      Object.entries(this.value.socialMedia).forEach(([x, y]) => {
        extra.push(...y);
      });

      Object.values(this.thirdOne).forEach((x) => {
        extra = extra.filter((item) => item !== x);
      });

      return extra;
    },
    getHeaderImg() {
      if (!this.expand) {
        return this.value.photo.profile ?? this.value.color ?? false;
      }

      return this.value.photo.headBackground ?? "";
    },
    computePrice() {
      if (this.value.singleProduct.discount) {
        const percent =
          (this.value.singleProduct.price * this.value.singleProduct.discount) /
          100;
        return this.value.singleProduct.price - percent;
      } else return false;
    },
    titleComputer() {
      if (this.value.subOrgan.length > 15) {
        return "15pt";
      } else return "25pt";
    },
    trancateTxts() {
      let about = this.value.singleProduct?.description;

      const more = about.split("<div>").length > 3;

      const text = () => {
        let variable = about.split("<div>");
        let generatedText = "";
        for (let a = 0; a <= 3; a++) {
          generatedText += "<div>" + variable[a];
        }
        return generatedText;
      };

      about =
        (about.length > 200 || more) && this.isTruncate
          ? (more ? text() : about.slice(0, 100)) + "&hellip;"
          : about;

      return about
        .replace(
          /style="width:604px;height:270px" /gms,
          'style="width:100%;height:auto"',
        )
        .replace(/style="display: block;padding-top: 57%"/gms, "");
      // return about.replace(/<div class="h_iframe-.*<iframe/gms, '<iframe ').replace(/ style="width:604px;height:270px" /gms, '');
    },
    trancateTxts1() {
      let about = this.value.aboutUs;

      const more = about.split("<div>").length > 3;

      const text = () => {
        let variable = about.split("<div>");
        let generatedText = "";
        for (let a = 0; a <= 3; a++) {
          generatedText += "<div>" + variable[a];
        }
        return generatedText;
      };

      about =
        (about.length > 200 || more) && this.isTruncate1
          ? (more ? text() : about.slice(0, 100)) + "&hellip;"
          : about;

      return about
        .replace(
          /style="width:604px;height:270px" /gms,
          'style="width:100%;height:auto"',
        )
        .replace(/style="display: block;padding-top: 57%"/gms, "");
      // return about.replace(/<div class="h_iframe-.*<iframe/gms, '<iframe ').replace(/ style="width:604px;height:270px" /gms, '');
    },
    btnSetting() {
      return this.value.singleProduct?.btnSetting?.show
        ? this.value.singleProduct.btnSetting
        : false;
    },
    hasExtra() {
      return !!this.value.singleProduct?.extra?.some((item) => {
        delete item.type;
        return !!Object.values(item).some((s) => !!s);
      });
    },
  },

  watch: {
    locationPage(val) {
      if (val) {
        this.locLoading = true;
        this.getlatLng();
      }
    },
  },

  methods: {
    openMap() {
      let agent = window.navigator.userAgent;
      let type = "https://www.google.com/maps/@";

      if (agent.toLowerCase().search("android") > 0) {
        type = "geo:";
      } else if (
        agent.search("iPad") > 0 ||
        agent.search("iPhone") > 0 ||
        agent.search("iPod") > 0
      ) {
        type = "maps:";
      }

      window.open(
        `${type}${this.value.coordinates[1]},${this.value.coordinates[0]}?q=${this.value.coordinates[1]},${this.value.coordinates[0]}`,
        "_blank",
      );
    },
    goToUrl(url, pattern = null) {
      let setUrl = "";
      const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

      if (!url.startsWith("http")) {
        if (emailRegex.test(url)) setUrl = "mailto:";
        else if (pattern)
          setUrl = pattern.startsWith("http") ? pattern : "https://" + pattern;
        else setUrl = "https://";
      }

      let a = document.createElement("a");
      a.setAttribute("href", setUrl + url);
      a.setAttribute("target", "_blank");
      a.click();
    },
    rangMe(url) {
      let a = document.createElement("a");
      a.setAttribute("href", `tel:${url}`);
      a.click();
    },
    getlatLng() {
      axios({
        method: "GET",
        baseURL: "https://map.ir/reverse",
        params: {
          lat: this.value.coordinates[1],
          lon: this.value.coordinates[0],
        },
        timeout: 15000,
        headers: {
          "x-api-key":
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.value.address = response.data.address;
        })
        .finally(() => (this.locLoading = false));
    },
    getVcf() {
      this.vcfLoading = true;

      const info = {
        fax: undefined,
        email: undefined,
        visitName: undefined,
        organizationName: undefined,
        subOrgan: undefined,
        userName: undefined,
        workField: undefined,
        phoneNumber: undefined,
        companyNumber: undefined,
        location: undefined,
        city: undefined,
        photo: undefined,
        codePostal: undefined,
        province: undefined,
        country: undefined,
        website: undefined,
        socialMedia: undefined,
        aboutUs: undefined,
        address: undefined,
      };

      Object.keys(info).forEach((x) => {
        info[x] = this.value[x];
      });
      axios
        .post(process.env.VUE_APP_VCF, info)
        .then((x) => {
          var a = document.createElement("a"); //Create <a>
          a.href = "data:text/vcard;charset=utf-8;base64," + x.data; //Image Base64 Goes here
          a.download = `${info.userName}.vcf`; //File name Here
          a.click(); //Downloaded file
        })
        .finally(() => (this.vcfLoading = false));
    },
    extraIsLink(item) {
      return item.link && item.link.length > 0;
    },
    fixLink(link) {
      return link.startsWith("http") ? link : "https://" + link;
    },
  },
};
</script>

<style lang="scss" scoped>
.expand-btn-enter-active,
.expand-btn-leave-active,
.fade-head-img-enter-active,
.fade-head-img-leave-active {
  transition: all 0.3s;
}

.expand-btn-enter, .expand-btn-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: rotate(720deg);
  opacity: 0.3;
}

.fade-head-img-enter,
.fade-head-img-leave-to {
  transform: scale(0.5);
  opacity: 0.3;
}

.content-holder {
  padding-top: 92px;

  &.contracted {
    .header-img-container {
      border-radius: 50% !important;
      top: 15px;
      right: 15px;
      height: 60px;
      width: 60px;
    }

    .sticky-name-holder {
      padding-right: 75px;
      top: 0;

      .v-btn {
        align-self: flex-start;
      }

      &::before,
      &::after {
        top: unset;
        bottom: 0;
      }

      &::before {
        transform: skewY(-37deg) translateY(32%) translateZ(-2px);
      }

      &::after {
        transform: skewY(-37deg) translateY(32%) translateZ(-1px);
      }
    }

    .btn-action {
      top: 76px;
    }

    .main-wrapper {
      background: white;
      padding: 12px;
      animation: main-anm-in 0.3s;
      animation-fill-mode: both;
      animation-delay: 0.3s;
    }

    .social-wrapper {
      animation: social-wrapper-anm-in 0.3s ease-out;
      animation-fill-mode: both;
    }

    .social-wrapper > .row > .col {
      animation: social-anm-in 0.3s ease-out;
      animation-fill-mode: both;
    }
  }

  &.expanded {
    .main-wrapper {
      display: none;
    }

    .btn-action {
      animation: btn-action-anm 5s;
      animation-delay: 2s;
      animation-iteration-count: infinite;
    }
  }

  .header-img-container {
    overflow: hidden;
    transition: all 0.3s;
    position: absolute;
    top: 0;
    right: 25px;
    z-index: 3;
    width: calc(100% - 25px);
    height: calc(100% - 95px);
    max-height: calc(100% - 95px);
  }

  .header-img-bg {
    display: block;
    width: 100%;
    max-width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .sticky-name-holder {
    display: flex;
    justify-content: space-between;
    transition: all 0.3s;
    position: absolute;
    top: calc(100% - 95px);
    width: 100%;
    padding: 8px;
    z-index: 2;
    transform-style: preserve-3d;

    &::before,
    &::after {
      transition: all 0.3s;
      content: "";
      top: 0;
      position: absolute;
      right: 0;
      width: 25px;
      height: 30px;
    }

    &::before {
      background: inherit;
      transform: skewY(37deg) translateY(-32%) translateZ(-2px);
    }

    &::after {
      background-color: rgba(0, 0, 0, 0.2);
      transform: skewY(37deg) translateY(-32%) translateZ(-1px);
    }

    .v-btn {
      align-self: center;
    }
  }

  .btn-action {
    transition: all 0.3s;
    z-index: 3;
    border: 3px solid white;
    right: 55px;
  }

  .main-wrapper,
  .social-wrapper {
    max-width: calc(100% - 25px);
    margin-right: auto;
  }

  .main-wrapper {
    overflow-y: auto;
    opacity: 0;
    transform: translateY(100px);
    width: 100%;
    min-height: 400px;
    height: calc(80vh - 184px);
    max-height: 655px;
    border-right: 1px solid rgba(0, 0, 0, 0.2);
  }

  .social-wrapper {
    padding: 8px;
    position: relative;
    z-index: 1;
    opacity: 0;
    transform: translateY(100%);
  }

  .social-wrapper > .row > .col {
    opacity: 0;
    transform: translateY(100%);
  }

  .social-wrapper > .row > .col:first-child {
    animation-delay: 0.3s;
  }

  .social-wrapper > .row > .col:nth-child(2) {
    animation-delay: 0.45s;
  }

  .social-wrapper > .row > .col:nth-child(3) {
    animation-delay: 0.6s;
  }

  .social-wrapper > .row > .col:nth-child(4) {
    animation-delay: 0.75s;
  }
}

.social-img {
  width: 30px;
  min-width: 30px;
  max-width: 30px;
}

@keyframes main-anm-in {
  from {
    opacity: 0;
    transform: translateY(100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes social-wrapper-anm-in {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes social-anm-in {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes btn-action-anm {
  0% {
    transform: scale(1) translateY(0) rotate(0);
  }
  5% {
    transform: scale(1.3) translateY(10px) rotate(15deg);
  }
  10% {
    transform: scale(1.4) translateY(15px) rotate(-15deg);
  }
  14% {
    transform: scale(0.8) translateY(-10px) rotateY(-180deg);
  }
  20% {
    transform: scale(1) translateY(0) rotate(0);
  }
}

pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
}

.link-tag {
  color: #0985d2 !important;
}

.link-tag:hover {
  color: #33a9f1 !important;
}
</style>
